import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Pressable } from 'react-native';
import { Text } from '~/components/core';
import { FONT_SIZE_M, FONT_SIZE_XL, FONT_SIZE_XS } from '~/constants';
import { scaleSize } from '~/constants/scale';
import { useStyles } from '~/hooks';
import { Theme } from '~/theme';
import t from '~/i18n';
import ScrollbarWrapper from '~/components/core/ScrollbarWrapper';
import config from '~/config';
import DesktopScreenHeader from '~/components/features/Desktop/DesktopScreenHeader';

type Props = {
    setAgreement: Function;
    setActiveRightTab?: Function;
};

export default function CopyTradingAgreementOld({ setAgreement, setActiveRightTab }: Props) {
    const styles = useStyles(stylesGenerator);
    const [agreementText, setAgreementText] = useState('');

    useEffect(() => {
        var messageContext: any = {};
        messageContext.brand = config.BRAND_NAME;
        setAgreementText(t.t('copy-trading-agreement-text-old', messageContext));
    }, []);

    return (
        <ScrollbarWrapper style={styles.container}>
            {setActiveRightTab ? (
                <DesktopScreenHeader
                    title="copy-trading-agreement"
                    goToScreenName="legal-documents"
                    setActiveRightTab={setActiveRightTab}
                />
            ) : null}
            <View style={styles.headContainer}>
                <Text fontType="LATO_ITALIC_BOLD" style={styles.headText}>
                    - IEC -
                </Text>
                <Text fontType="LATO_ITALIC_BOLD" style={styles.headText}>
                    Social Trading Features & CopyTrading Services Terms & Conditions
                </Text>
            </View>
            <View style={styles.contentContainer}>
                <View style={styles.pleaseConfirm}>
                    <Text fontType="LATO_REGULAR" style={styles.confirmSectionTitle}>
                        {agreementText}
                    </Text>
                </View>

                <View style={[styles.closeTradeContainer]}>
                    <Pressable
                        style={() => [
                            [
                                styles.background_closeTradeButton,
                                styles.closeTradeButtonWidth,
                                styles.background_closeTradeButtonUnPressed,
                            ],
                        ]}
                        onPress={() => {
                            setAgreement(false);
                        }}
                    >
                        <Text fontType="LATO_BOLD" style={styles.background_closeTradeButtonText}>
                            Close
                        </Text>
                    </Pressable>
                </View>
                <View style={styles.footerTextContainer}>
                    <Text fontType="LATO_ITALIC" style={styles.footerText}>
                        copy-trading-confirmation-footer-text1
                    </Text>
                    <Text fontType="LATO_ITALIC" style={styles.footerText}>
                        copy-trading-confirmation-footer-text2
                    </Text>
                </View>
            </View>
        </ScrollbarWrapper>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        closeTradeButtonWidth: { width: scaleSize(100) },
        background_closeTradeButtonUnPressed: {
            backgroundColor: theme.background_closeTradeButtonPressed,
        },
        closeTradeContainer: {
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: scaleSize(20),
        },
        background_closeTradeButtonText: {
            color: theme.background_closeTradeButton,
        },
        background_closeTradeButton: {
            justifyContent: 'center',
            alignItems: 'center',
            height: scaleSize(25),
            borderRadius: scaleSize(2),
            borderColor: theme.background_closeTradeButton,
            borderWidth: 1,
        },
        linkPart3: { paddingLeft: scaleSize(10) },
        checkboxContainerRow1: { flexDirection: 'row' },
        checkboxtextGreen: { fontSize: FONT_SIZE_XS, color: theme.tabIconSelected },
        footerText: {
            fontSize: FONT_SIZE_XS,
            color: theme.wallet_text,
        },
        footerTextContainer: { paddingVertical: scaleSize(12), justifyContent: 'center', alignItems: 'center' },
        checkboxtext: { fontSize: FONT_SIZE_XS, color: theme.wallet_text, paddingLeft: scaleSize(10) },
        confirmSectionTitle: { fontSize: FONT_SIZE_M, color: theme.wallet_text },
        pleaseConfirm: {
            paddingTop: scaleSize(20),
            paddingBottom: scaleSize(15),
            justifyContent: 'center',
            alignItems: 'center',
        },
        contentContainer: { paddingHorizontal: scaleSize(25), backgroundColor: theme.background },
        headRowText: {
            paddingLeft: scaleSize(10),
            fontSize: FONT_SIZE_XS,
            color: theme.text_positionsCount,
        },
        headIcon: { color: theme.text_positionsCount },
        head2RowContainer: { flexDirection: 'row', height: '33.33%', alignItems: 'center' },
        secureLine: {
            width: '100%',
            height: 1,
            backgroundColor: theme.switch_trackOn,
            top: scaleSize(25),
        },
        helfBackground: {
            backgroundColor: theme.background_closeTradeButtonPressed,
            height: scaleSize(25),
            position: 'absolute',
            width: '100%',
            top: 0,
        },
        secureIconRing: {
            width: scaleSize(44),
            height: scaleSize(44),
            borderWidth: 1,
            borderColor: theme.white,
            borderRadius: scaleSize(22),
            justifyContent: 'center',
            alignItems: 'center',
        },
        secureIconBackground: {
            width: scaleSize(50),
            height: scaleSize(50),
            backgroundColor: theme.switch_trackOn,
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: scaleSize(25),
        },
        secureIconContainer: {
            justifyContent: 'center',
            alignItems: 'center',
        },
        secureIcon: { color: theme.white },
        headText: { fontSize: FONT_SIZE_XL, color: theme.white, textAlign: 'center' },
        headContainer: {
            width: '100%',
            backgroundColor: theme.switch_trackOn,
            justifyContent: 'center',
            alignItems: 'center',
            paddingVertical: scaleSize(20),
            paddingHorizontal: scaleSize(15),
            textAlign: 'center',
        },
        headContainer2: {
            height: scaleSize(140),
            backgroundColor: theme.background_closeTradeButtonPressed,
            paddingHorizontal: scaleSize(28),
        },
        container: {
            flex: 1,
            height: '100%',
            justifyContent: 'flex-start',
            alignSelf: 'center',
            width: '100%',
        },
        checkboxContainer: {
            paddingBottom: scaleSize(20),
            justifyContent: 'flex-start',
            flexDirection: 'row',
        },
    });
